var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.selectMood},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("显示新广告的现有心情，评论和分享")]),(_vm.checked)?_c('p',{staticClass:"tips"},[_vm._v("勾选之后，广告将不能编辑")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }